import { createReducer } from 'redux-create-reducer';
import {
  CREATE_REVIEW_FAILURE,
  CREATE_REVIEW_SUCCESS,
  CREATING_REVIEW,
  REVIEW_FETCHED,
  SAVE_COMMENT,
  SELECT_FIXT_RATING,
  SELECT_TECH_RATING,
} from '../actions';

const initialState = {
  comments: '',
  error: false,
  fixtRating: 0,
  loading: false,
  submitted: false,
  techRating: 0,
};

const events = {
  [REVIEW_FETCHED]: (state, { review }) => {
    return {
      ...state,
      comments: review.comments,
      fixtRating: review.fixt_rating,
      submitted: true,
      techRating: review.tech_rating,
    };
  },

  [SELECT_FIXT_RATING]: (state, { rating }) => {
    return { ...state, fixtRating: rating };
  },

  [SAVE_COMMENT]: (state, { comment }) => {
    return { ...state, comment };
  },

  [SELECT_TECH_RATING]: (state, { rating }) => {
    return { ...state, techRating: rating };
  },

  [CREATING_REVIEW]: state => {
    return { ...state, loading: true };
  },

  [CREATE_REVIEW_SUCCESS]: state => {
    return {
      ...state,
      loading: false,
      submitted: true,
      error: false,
    };
  },

  [CREATE_REVIEW_FAILURE]: state => {
    return { ...state, loading: false, error: true };
  },
};

export default createReducer(initialState, events);
